<!-- 图书柜-卖书-开箱 -->
<template>
  <div class="BookcasePay">
    <div class="successBox">
      <p class="text">已为您打开{{$store.state.ECMall_activeGoods.gridno}}号箱格</p>
      <p class="pText color" v-if="$store.state.eUserInfo.operateType === 'save'">请将打印的商品身份码贴在书后<br/>放入书后并随手关门</p>
      <p class="pText" v-else>请取出商品后并随手关门</p>

      <!-- mqtt  -->
      <Mqttws ref="mqttws" :topic="topic" msgIsHex @getMessage="getLockStatus"></Mqttws>
    </div>
  </div>
</template>

<script>
  import Mqttws from '@/components/Bookcase/Common/Mqttws'
  import { storage } from '../../../../static/js/utils/utility'
  import { checkData, hex_to_ten, hexCharCodeToStr } from '../../../../static/js/utils/util'
  import * as config from '../../../../static/js/config.js'
  let vm, timer

  export default {
    name:'BookcasePay',
    components: {
      Mqttws
    },
    computed: {
    },
    data() {
      return {
        topic: '/'+ config.deviceId + '/report/' + config.serverPort2 + '/environment/protocol', // 锁状态上报订阅主题
      }
    },
    created() {
      vm = this
      // 初始化预警信息(存物未关箱3, 取物未关箱4)
      vm.$store.state.ECMall_warningData = {
        user_id: vm.$store.state.eUserInfo.user_id,
        type: vm.$store.state.eUserInfo.operateType == 'get' ? 4 : 3,
        pid: vm.$store.state.ECMall_activeGoods.pid
      }
    },
    mounted () {
      console.log('this', this.$route)
    },
    methods: {
      // mqtt获取锁状态
      getLockStatus (data) {
        console.log('mqtt返回信息：', data)
        if (data) {
          var str = data.substring(2,data.length-2);//截取字符串的第二到倒数第二的数据
          var num = checkData(str)      // bcc
          let func = data.substring(28, 32)   // 功能码
          var bbc = data.substr(data.length-2)  // 计算得到的bcc码
          // 校验bbc是否正确
          if (num === bbc && func == 'e501') {
            // 锁状态（aa表示锁为关闭状态，55表示锁开状态）、锁编号
            let status = data.substring(data.length-4, data.length-2)
            let lockNum = data.substring(data.length-6, data.length-4)
            // console.log('status', status)
            // 锁已关闭
            if (status === 'aa') {
              // 清除预警信息
              vm.$store.state.ECMall_warningData = {}
              vm.$router.push('/Bookcase/SCloseBox')
            // 锁开状态
            } else {
              console.log('锁为开状态', '')
            }
          } 
          // else {
          //   messageError('获取箱门状态失败')
          // }
        }
      },
      // 去支付
      goPay () {
        vm.$router.push('/Bookcase/Pay')
      }
    },
    watch: {
    },
  }
</script>

<style lang="less">
.Bookcase{
  .BookcasePay {
    width: 100%;
    height: 100%;
    padding: 0.52rem 0.42rem 0.62rem;
    display: flex;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bookcase/Sell/SOpenBox.vue